
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import Headers from "../Header";
import Footer from "../Footer";
import ScrollToTop from "../ScrollToTopButton/ScrollToTop"


const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Headers />
      {/* Navigation placeholder - would be replaced by your actual Navbar */}
      <div className="h-16 bg-white shadow"></div>
      
      {/* Hero section */}
      <section className="bg-gradient-to-b from-primary/10 to-white py-10">
        <div className="container mx-auto px-4 text-center">
          <motion.h1 
            initial={{ opacity: 0, y: -20 }} 
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-4xl md:text-5xl font-bold mb-6"
          >
            About AssessPro
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-xl text-gray-700 max-w-3xl mx-auto mb-8"
          >
            Our mission is to transform how organizations evaluate talent through powerful, 
            fair, and accessible assessment solutions.
          </motion.p>
<div className="flex justify-center">
  <img 
    src="https://img.freepik.com/free-vector/office-work-school-education-man-writing-chart-board-woman-designer-drawing-graphic-tablet-teacher-stand-knee-giving-book-little-girl-with-schoolbag_33099-2516.jpg?uid=R202375562&ga=GA1.1.693226630.1720413106&semt=ais_hybrid&w=740" 
    alt="Education illustration" 
    className="max-w-full h-auto"
  />
</div>
        </div>
      </section>
      
      {/* Content section */}
      <section className="py-2">
        <div className="container mx-auto px-4 max-w-4xl">
           
          <div className="prose prose-lg mx-auto mb-20px">
            
            <h2 className="py-4">Our Story</h2>
            <p >
              Founded in 2018 by a team of HR professionals and software engineers, 
              AssessPro was born from a simple observation: traditional assessment methods 
              weren't keeping pace with modern work requirements.
            </p>
            <p >
              We saw firsthand how companies struggled with outdated evaluation tools, 
              while candidates faced assessments that often didn't reflect their true abilities.
            </p>
            <p >
              Our platform was built to solve these challenges by providing a comprehensive, 
              fair, and efficient way to evaluate candidates that saves time for recruiters 
              and offers a better experience for candidates.
            </p>
            
            <h2 className="py-4">Our Team</h2>
            <p >
              We're a diverse team of HR specialists, software developers, psychometricians, 
              and customer success professionals dedicated to building the best assessment 
              platform possible.
            </p>
            <p >
              With experience from leading technology and HR companies, our team combines 
              technical expertise with deep knowledge of recruitment and talent evaluation.
            </p>
            
            <h2 className="py-4">Our Values</h2>
            <ul>
              <li><strong>Fairness:</strong> We're committed to reducing bias in hiring through objective assessments.</li>
              <li><strong>Innovation:</strong> We continuously improve our platform with the latest in assessment science.</li>
              <li><strong>Security:</strong> We protect sensitive data with the highest security standards.</li>
              <li><strong>Customer Success:</strong> We measure our success by our customers' success.</li>
            </ul>
            
            <h2 className="py-4">Join Our Journey</h2>
            <p>
              Today, AssessPro is trusted by hundreds of organizations worldwide, from 
              startups to Fortune 500 companies. We're just getting started on our mission 
              to transform assessment practices globally.
            </p>
          </div>
          
          <div className="text-center mt-16">
            <Button 
              size="lg" 
              asChild
            >
              <Link to="/register">Start Your Free Trial</Link> 
            </Button>
          </div>
        </div>
      </section>
      
      {/* Footer placeholder - would be replaced by your actual Footer */}
      <div className="bg-gray-900 text-white py-16">
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default About;
